import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from '../locales/en/common.json';
import esTranslation from '../locales/es/common.json';
import ptTranslation from '../locales/pt/common.json';

import enSales from '../locales/en/sales.json';
import esSales from '../locales/es/sales.json';
import ptSales from '../locales/pt/sales.json';

import enDashboard from '../locales/en/dashboard.json';
import esDashboard from '../locales/es/dashboard.json';
import ptDashboard from '../locales/pt/dashboard.json';

import enUsers from '../locales/en/users.json';
import esUsers from '../locales/es/users.json';
import ptUsers from '../locales/pt/users.json';
import enSupport from '../locales/en/support.json';
import esSupport from '../locales/es/support.json';
import ptSupport from '../locales/pt/support.json';

import enFinance from '../locales/en/finance.json';
import esFinance from '../locales/es/finance.json';
import ptFinance from '../locales/pt/finance.json';

import enWorkspaces from '../locales/en/workspaces.json';
import esWorkspaces from '../locales/es/workspaces.json';
import ptWorkspaces from '../locales/pt/workspaces.json';

import enAuth from '../locales/en/auth.json';
import esAuth from '../locales/es/auth.json';
import ptAuth from '../locales/pt/auth.json';

const resources = {
  en: {
    common: enTranslation,
    sales: enSales,
    dashboard: enDashboard,
    users: enUsers,
    support: enSupport,
    finance: enFinance,
    workspaces: enWorkspaces,
    auth: enAuth,
  },
  es: {
    common: esTranslation,
    sales: esSales,
    dashboard: esDashboard,
    users: esUsers,
    support: esSupport,
    finance: esFinance,
    workspaces: esWorkspaces,
    auth: esAuth,
  },
  pt: {
    common: ptTranslation,
    sales: ptSales,
    dashboard: ptDashboard,
    users: ptUsers,
    support: ptSupport,
    finance: ptFinance,
    workspaces: ptWorkspaces,
    auth: ptAuth,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'pt'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    ns: ['common', 'sales', 'dashboard', 'users', 'support', 'finance', 'workspaces', 'auth'],
    defaultNS: 'common',
  });

export default i18n; 